import { sodApi } from '@/services'

export interface SubmitUserFeedbackRequest {
  type: number
  option: number | null
  text: string
  referenceId: string
  referenceType: UserFeedbackReferenceType
}

interface SubmitUserFeedbackResponse {
  success: boolean
  message?: string
}

export enum UserFeedbackReferenceType {
  Annotation = 1,
  Appropriateness = 2,
}

export const userFeedbackApi = sodApi.injectEndpoints({
  endpoints: (builder) => ({
    submitUserFeedback: builder.mutation<
      SubmitUserFeedbackResponse,
      SubmitUserFeedbackRequest
    >({
      query: (feedback) => ({
        url: '/UserFeedback/Submit',
        method: 'POST',
        body: feedback,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),
  }),
})

export const { useSubmitUserFeedbackMutation } = userFeedbackApi